/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, Input, OnInit } from '@angular/core';
import {
  EPGImageFormat,
  EPGImageSliderItem
} from '../../../../../../../../../app/shared/epg-image-slider/epg-image-slider.component';

@Component({
  selector: 'record-image',
  templateUrl: './record-image.component.html',
  styleUrls: ['./record-image.component.scss'],
  standalone: false
})
export class RecordImageComponent implements OnInit {
  @Input() images!: EPGImageSliderItem[];
  @Input() imageFormat?: EPGImageFormat = EPGImageFormat.BASE64;
  @Input() respectOriginalAspectRatio? = false;
  @Input() disableLightBox? = false;

  constructor() {}

  ngOnInit(): void {}
}
